export default "__VITE_ASSET__ee0c87ac__"